import { render, staticRenderFns } from "./successPop.vue?vue&type=template&id=552d434a&"
import script from "./successPop.vue?vue&type=script&setup=true&lang=js&"
export * from "./successPop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports